import { customElement, property } from 'lit/decorators.js';
import { State, StateController } from '@common/lit/store';
import { componentStateStore } from '@src/store';

import { BaseComponent } from './BaseComponent';

@customElement('tef-coms-button')
export class TefComsButton extends BaseComponent {
  store : StateController<State>;

  @property({ type: String }) text : string = '?';

  constructor() {
    super();
    // This is needed in every component using the store to make it reactive (See lit ReactiveController)
    this.store = new StateController(this, componentStateStore);
  }

  override render() {
    return this.getTemplateFn('tefComsButton')();
  }

  handleClick(event : PointerEvent) {
    if (componentStateStore.disabled) {
      event.stopPropagation();
    }
  }

  // Render into lightDOM
  protected createRenderRoot() {
    return this;
  }
}
